<template>
  <v-row justify="center">
    <v-tooltip left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          small
          fixed
          bottom
          right
          fab
          v-bind="attrs"
          v-on="on"
          @click.stop="dialog = true"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
      <span>Crear Grupo</span>
    </v-tooltip>

    <v-dialog
      v-model="dialog"
      max-width="490"
    >
      <v-card>
        <v-card-title class="headline text-left">
          Crear Grupo
        </v-card-title>

        <v-card-text>
          <p>
            Crea un grupo para poder invitar a tus estudiantes y ver su progreso.
          </p>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-text-field
              v-model="groupName"
              label="Nombre del Grupo"
              prepend-icon="mdi-account-multiple-plus-outline"
              :rules="groupNameRules"
            />
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            color="green darken-1"
            text
            @click="close"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="createGroup"
          >
            Crear
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    data () {
      return {
        valid: true,
        dialog: false,
        groupName: '',
        groupNameRules: [
          v => !!v || 'Nombre de grupo es requerido',
          v => !this.groupNameExist || 'El nombre del grupo ya existe',
        ],
      }
    },
    computed: {
      ...mapState(['userData']),
      groupNameExist () {
        return this.userData.groups.map(g => g.name).includes(this.groupName)
      },
    },
    watch: {
      dialog (val) {
        val || this.$refs.form.reset()
      },
    },
    methods: {
      close () {
        this.$refs.form.reset()
        this.dialog = false
      },
      createGroup () {
        if (this.$refs.form.validate()) {
          const groupNew = {
            name: this.groupName,
            students: [],
          }
          this.$store.dispatch('CREATE_GROUP', groupNew)
          this.close()
        } else {
          console.log('Faltan datos')
        }
      },
    },
  }
</script>
